import * as React from "react";
import {none, option} from "ts-option";
import Map from "../map/Map";
import MarkerWithInfoWindow from "../map/MarkerWithInfoWindow";
import MapUtils from "../../utils/MapUtils";
import {getUserLocation} from "../../store/view/user";
import AppointmentDetails from "../../model/appointment/AppointmentDetails";
import User from "../../model/user/User";
import deepEqual = require("deep-equal");
import GoogleMapsIcon = google.maps.Icon;

interface Props {
	/**
	 * Lattitude and langitude passed to map.
	 */
	center: {
		lat: number,
		lng: number
	};
	/**
	 * Indicates if engineer homes are displayed on map
	 */
	displayHomes: boolean;
	/**
	 * Indicates if engineer locations are displayed on map
	 */
	displayLocations: boolean;
	/**
	 * Indicates if appointments are displayed on map
	 */
	displayAppointments: boolean;
	/**
	 * Appointments to show on a map (with locations).
	 */
	appointments: AppointmentDetails[],
	/**
	 * Sales engineers with home GPS locations.
	 */
	salesEngineers: User[],
}

export default class DayViewMap extends React.Component<Props, {}> {
	shouldComponentUpdate(nextProps: Readonly<Props>) {
		return !deepEqual(nextProps, this.props);
	}

	render() {
		return (
			<Map center={this.props.center} zoom={9}>
				{this.renderAppointmentsMarkers()}
				{this.renderHomes()}
				{this.renderLocations()}
			</Map>
		);
	}

	renderAppointmentsMarkers() {
		if (!this.props.displayAppointments) {
			return null;
		}
		return this.props.appointments.map((details, index) => {
			const event = details.toEvent();
			return (
				<MarkerWithInfoWindow key={index}
									  position={details.location.get}
									  infoText={none}
									  icon={{
										  url: MapUtils.getEventMarker(event),
										  scaledSize: {width: 48, height: 48}
									  } as GoogleMapsIcon}
									  event={option(event)}/>
			)
		});
	}

	renderHomes() {
		if (!this.props.displayHomes) {
			return null;
		}
		return this.props.salesEngineers.map((engineer, index) => {
			return engineer.data.homeAddressLocation.map(location => {
				const seName = engineer.getDisplayName(true);
				const seAddress = engineer.data.homeAddress.map(a => a.displayName()).getOrElse("");
				return (
					<MarkerWithInfoWindow key={index}
										  position={location}
										  icon={{
											  url: MapUtils.getHomeMarker(engineer.id),
											  scaledSize: {width: 48, height: 48}
										  } as GoogleMapsIcon}
										  event={none}
										  infoText={option(`${seName}\n\n${seAddress}`)}/>
				)
			}).orNull;
		});
	}

	renderLocations() {
		if (!this.props.displayLocations) {
			return null;
		}
		return this.props.salesEngineers.map((engineer, index) => {
			const userLocation = getUserLocation(engineer.id);
			return (
				userLocation.map(ul => {
						return (
							<MarkerWithInfoWindow key={index}
												  position={{lat: ul.latitude, lng: ul.longitude}}
												  icon={{
													  url: MapUtils.getSEInitialsMarker(engineer),
													  scaledSize: {width: 48, height: 48}
												  } as GoogleMapsIcon}
												  infoText={none}
												  event={none}/>
						)
					}
				).orNull
			)
		});
	}
}